import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { BlobServiceClient } from "@azure/storage-blob";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import axios from "axios";

import { Row, Col, Table, Form, Button } from "react-bootstrap";

export class UpgradeProduct extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedLicenseType: "",
      selectedTotalUsers: "",
      selectedDataRetensionMonths: "",
      selectedEnableSEO: "",
      selectedEnableAutoScale: "",
      selectedTransactionCharges: 0,

      newStoreStartDate: "",
      newStoreEndDate: "",
      newStoreLastRenewalDate: "",
      upgradeStatus: "",
      license: [
        {
          LicenseTypeName: "Standard",
          LicenseTypeId: 2,
          TotalUsers: 1,
          DataRetention: 12,
          enableSEO: false,
        },
        {
          LicenseTypeName: "Professional",
          LicenseTypeId: 3,
          TotalUsers: 3,
          DataRetention: 24,
          enableSEO: false,
        },
        {
          LicenseTypeName: "Premium",
          LicenseTypeId: 5,
          TotalUsers: 5,
          DataRetention: 36,
          enableSEO: false,
        },
      ],
    };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnChangeLicenseType = (e) => {
    if (e.target.checked) {
      this.setState({ selectedLicenseType: e.target.name });
      if (e.target.name == this.context.LicenseType.STANDARD) {
        this.setState({ selectedTotalUsers: 1 });
        this.setState({ selectedDataRetensionMonths: 12 });
        this.setState({ selectedEnableSEO: false });
      }
      if (e.target.name == this.context.LicenseType.PROFESSIONAL) {
        this.setState({ selectedTotalUsers: 3 });
        this.setState({ selectedDataRetensionMonths: 24 });
        this.setState({ selectedEnableSEO: false });
      }
      if (e.target.name == this.context.LicenseType.PREMIUM) {
        this.setState({ selectedTotalUsers: 5 });
        this.setState({ selectedDataRetensionMonths: 36 });
        if (
          this.context.IsECommerceProduct(
            this.context.selectedProduct.productTypeId
          ) == true
        ) {
          this.setState({ selectedEnableSEO: true });
        } else this.setState({ selectedEnableSEO: false });
      }
    }
  };

  //Get Base Cost of the Store
  // GetBaseCost = (store) => {
  //   if (store.storeTypeId == this.context.LicenseType.FREE) {
  //     return 0;
  //   } else {
  //     var tot =
  //       Number(store.monthlyCost) +
  //       (store.totalUsers - 1) *
  //         this.context.selectedProduct.additionalUserCost +
  //       Number(store.dataRetensionMonthlyCost);
  //     if (store.enableSeo == true) {
  //       tot += this.context.GetEcSettingValueByName("SeoCost");
  //     }
  //     return tot;
  //   }
  // };

  //Get Monthly Cost based on License Type
  // GetMonthlyCost = (LicenseTypeId) => {
  //   if (LicenseTypeId == "0") return 0;

  //   var totUsers = 0;
  //   var dataRetentionCost = 0;
  //   var enableSEO = false;
  //   if (LicenseTypeId == this.context.LicenseType.STANDARD) {
  //     totUsers = 1;
  //     dataRetentionCost = this.context.GetEcSettingValueByName("dataRententionOneYear");
  //     enableSEO = false;
  //   } else if (LicenseTypeId == this.context.LicenseType.PROFESSIONAL) {
  //     totUsers = 3;
  //     dataRetentionCost = this.context.GetEcSettingValueByName("dataRentention2Years");
  //     enableSEO = false;
  //   } else if (LicenseTypeId == this.context.LicenseType.PREMIUM) {
  //     totUsers = 5;
  //     dataRetentionCost = this.context.storeSettings.dataRentention3Years;
  //     enableSEO = false;
  //     if (
  //       this.context.IsECommerceProduct(
  //         this.context.selectedProduct.productTypeId
  //       )
  //     )
  //       enableSEO = true;
  //   }

  //   var prod = this.context.prods.filter(
  //     (f) => f.productType == this.context.selectedProduct.productTypeId
  //   )[0];

  //   var tot =
  //     Number(prod.monthlyCost) +
  //     (totUsers - 1) * this.context.selectedProduct.additionalUserCost +
  //     Number(dataRetentionCost);
  //   if (enableSEO == true) {
  //     tot += this.context.GetEcSettingValueByName("SeoCost");
  //   }
  //   return tot;
  // };

  GetAvailableCreditDays = () => {
    let expirydate = new Date(this.context.selectedProduct.storeEnd);
    const diffTime = Math.abs(new Date() - expirydate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  GetAvailableCredit = () => {
    if (
      this.context.selectedProduct.licenseTypeId ==
      this.context.LicenseType.FREE
    )
      return 0;

    let lastRenewalDate = "";
    if (this.context.selectedProduct.storeLastRenewalDate == null)
      lastRenewalDate = new Date(this.context.selectedProduct.storeStart);
    else
      lastRenewalDate = new Date(
        this.context.selectedProduct.storeLastRenewalDate
      );

    //Get Per year cost
    let perYearCost =
      this.context.GetMonthlyCostOfStore(this.context.selectedProduct) * 12;
    let perDayCost = perYearCost / 365;

    //Get last paid cost
    let expirydate = new Date(this.context.selectedProduct.storeEnd);
    const diffTime = Math.abs(lastRenewalDate - expirydate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // let lastpaid = 0;
    // lastpaid = perYearCost * (diffDays / 365);

    //Get per day Cost
    //let perDayCost = lastpaid / diffDays;

    const diffTime1 = Math.abs(new Date() - expirydate);
    const availableCreditDays = Math.ceil(diffTime1 / (1000 * 60 * 60 * 24));

    return availableCreditDays * perDayCost;
  };

  GetUpgradeAmount = (licenseType) => {
    if (licenseType == "") return 0;
    // Get Available Credit Amount and Credit Days
    let expirydate = new Date(this.context.selectedProduct.storeEnd);
    const diffTime1 = Math.abs(new Date() - expirydate);
    const availableCreditDays = Math.ceil(diffTime1 / (1000 * 60 * 60 * 24));
    const availableCreditAmount = this.GetAvailableCredit();

    if (
      this.context.selectedProduct.storeTypeId == this.context.LicenseType.FREE
    ) {
      let upgradeAmount =
        this.context.GetPriceOfSelectedProductByLicenseType(licenseType) * 12;
      return upgradeAmount;
    } else {
      let perDayCostAsPerNewPlan =
        (this.context.GetPriceOfSelectedProductByLicenseType(licenseType) *
          12) /
        365;
      let newcost = availableCreditDays * perDayCostAsPerNewPlan;
      let upgradeAmount = newcost - availableCreditAmount;
      return upgradeAmount;
    }
  };

  GetUpgradeAmountWithTax = () => {
    return (
      this.GetUpgradeAmount(this.state.selectedLicenseType) +
      (this.GetUpgradeAmount(this.state.selectedLicenseType) *
        Number(this.context.GetEcSettingValueByName("taxPercentage"))) /
        100
    );
  };

  CallRazorPay = async () => {
    var ordid = "order_" + new Date().getTime();
    var custName = "";
    var emailId = "";
    var mobileNo = "";

    if (this.context.userData.loginStatus === "active") {
      custName = this.context.userData.firstName;
      emailId = this.context.userData.emailId;
      mobileNo = this.context.userData.contactNo;
    }

    var result = await axios.post(
      process.env.REACT_APP_API +
        "sales/CreateRazorpayOrder/" +
        ordid +
        "/" +
        Math.round(this.GetUpgradeAmountWithTax(), 0) * 100
    );
    if (!result) {
      alert("Server error. Please try later");
      return;
    }

    var options = {
      key: this.context.GetEcSettingValueByName("razorpayKey"),
      key_secret: this.context.GetEcSettingValueByName("razorpayKeySecret"),
      // amount: 1 * 100,
      amount: Math.round(this.GetUpgradeAmountWithTax(), 0) * 100,
      currency: this.context.GetEcSettingValueByName("razorpayCurrency"),
      name: this.context.GetEcSettingValueByName("razorpayCompanyName"),
      description: this.context.GetEcSettingValueByName(
        "razorpayCompanyDescription"
      ),
      order_id: result.data.Attributes["id"],
      handler: (response) => {
        this.SuccessRazorPayResponse(ordid, response);
      },
      prefill: {
        name: custName, //customer name
        email: emailId, //customer emailId
        contact: mobileNo, //customer phoneno
      },
      notes: {
        address: this.context.GetEcSettingValueByName("razorpayCompanyAddress"),
      },
      theme: {
        color: this.context.GetEcSettingValueByName("razorpayThemeColor"),
      },
      modal: {
        escape: false,
        ondismiss: () => {
          this.context.UpdateOrderStatus("Dismissed");
        },
      },
    };
    var pay = window.Razorpay(options);
    //var rzp1 = new Razorpay(options);
    //pay.on("payment.failed", function (response) {
    pay.on("payment.failed", (response) => {
      this.FailedInRazorPayResponse(response);
    });
    pay.open();
  };
  FailedInRazorPayResponse = (response) => {
    this.context.UpdateOrderStatus("Failed");
  };
  SuccessRazorPayResponse = (orderId, response) => {
    this.SubmitOrder(orderId, response);
    console.log(response.razorpay_payment_id);
  };

  SubmitOrder = (orderId, response) => {
    this.ShowLoadSpinner();

    var str = {
      tenantId: this.context.userData.id,
      orderType: 2, //upgrade Product
      storeId: this.context.selectedProduct.id,
      businessName: this.context.selectedProduct.name,
      productName: this.context.selectedProduct.name,
      productType: this.context.selectedProduct.productTypeId,
      licenseType: this.state.selectedLicenseType,
      monthlyCost: this.context.prods.filter(
        (f) => f.productType == this.context.selectedProduct.productTypeId
      )[0].monthlyCost,
      totalUsers: this.state.selectedTotalUsers,
      dataRetensionMonths: this.state.selectedDataRetensionMonths,
      enableSEO: this.state.selectedEnableSEO,
      paidAmt: this.GetUpgradeAmountWithTax(),
      paymentModeId: 1, //1 Razorpay --2 Bank Account

      // paymentTransactionId: razorpayTransactionId,
      razorpayOrderId: response.razorpay_order_id,
      razorpayPaymentId: response.razorpay_payment_id,
      razorpaySignature: response.razorpay_signature,
      paymentTransactionId: response.razorpay_payment_id,

      transactionCharges:
        this.context.IsECommerceProduct(
          this.context.selectedProduct.productTypeId
        ) == true
          ? "1.5"
          : "0",
      paymentStatusId: 1, //1 Paid 2 Unpaid 3 Partially Paid
      status: 3, //1 NewOrder 2 InProgress 3 Complete 4 Cancelled
    };
    axios
      .post(process.env.REACT_APP_API + "Sales/SubmitOrder", str)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            confirmButtonColor: "#23B14D",
            text: "Upgraded Successfully!",
            confirmButtonText: "Ok",
          }).then((result) => {
            this.setState({ upgradeStatus: "Success" });
          });
          this.HideLoadSpinner();
        } else {
          alert("Failed. Please try later!");
          this.HideLoadSpinner();
        }
      })
      .catch((error) => {
        alert("Failed. Please try later!", error);
        this.HideLoadSpinner();
      });
  };

  handleSubmit = () => {
    this.CallRazorPay();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    if (this.context.userData.loginStatus != "active")
      return <Navigate to="/home" />;
    if (this.state.upgradeStatus == "Success")
      return <Navigate to="/MyProducts" />;

    return (
      <>
        <div className="container">
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <br />
          <h1 className="text-center">Upgrade Product License</h1>
          <hr />
          <br />
          <Row>
            <Col>
              <h3 className="text-primary">
                Product Name: {this.context.selectedProduct.name}
              </h3>
            </Col>
          </Row>
          <h2 className="pt-5 text-start">Current Plan</h2>
          <Table>
            <thead>
              <tr className="text-center bg-light">
                <th></th>
                <th>License Plan</th>
                <th>Total User Access</th>
                <th>Data Retention Period</th>
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) == true ? (
                  <>
                    <th>SEO & Independent Hosting</th>
                  </>
                ) : (
                  <></>
                )}
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) == true ? (
                  <>
                    <th>Auto Scaling [unlimited users access]</th>
                  </>
                ) : (
                  <></>
                )}

                <th>Monthly Cost</th>
                <th>Yearly Cost</th>
                <th>License Expiry Date</th>
                <th>Remaining Credit Days</th>
                <th>Remaining Credit Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <td>&nbsp;&nbsp;&nbsp;&nbsp; </td>
                <td>
                  <h5>
                    {this.context.GetLicenseTypeNameById(
                      this.context.selectedProduct.storeTypeId
                    )}
                  </h5>
                </td>
                <td>{this.context.selectedProduct.totalUsers}</td>
                <td>
                  {this.context.selectedProduct.dataRetensionMonths == 0 ? (
                    this.context.GetEcSettingValueByName(
                      "dataRententionFreeDays"
                    ) + " Days"
                  ) : (
                    <>
                      {this.context.selectedProduct.dataRetensionMonths +
                        " Months"}
                    </>
                  )}
                </td>
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) == true ? (
                  <>
                    <td>
                      {this.context.selectedProduct.enableSEO == true
                        ? "Enabled"
                        : "Disabled"}
                    </td>
                  </>
                ) : (
                  <></>
                )}
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) == true ? (
                  <>
                    <td>
                      {this.context.selectedProduct.transactionCharges}%
                      Transaction Fee on Online Sale{" "}
                    </td>
                  </>
                ) : (
                  <></>
                )}

                <td>
                  {this.context
                    .GetPriceOfSelectedProductByLicenseType(
                      this.context.selectedProduct.storeTypeId
                    )
                    .toLocaleString("en-IN", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                      style: "currency",
                      currency: "INR",
                    })}
                </td>
                <td>
                  {(
                    this.context.GetPriceOfSelectedProductByLicenseType(
                      this.context.selectedProduct.storeTypeId
                    ) * 12
                  ).toLocaleString("en-IN", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    style: "currency",
                    currency: "INR",
                  })}
                </td>
                <td>
                  {" "}
                  {this.context.GetInDateFormat(
                    new Date(this.context.selectedProduct.storeEnd)
                  )}
                </td>
                <td>{this.GetAvailableCreditDays()}</td>
                <td>
                  {this.GetAvailableCredit().toLocaleString("en-IN", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    style: "currency",
                    currency: "INR",
                  })}
                </td>
              </tr>
            </tbody>
          </Table>

          <h2 className="py-3 text-start">Upgrade To</h2>
          <Table hover>
            <thead>
              <tr className="text-center bg-light">
                <th></th>
                <th>License Plan</th>
                <th>Total User Access</th>
                <th>Data Retention Period</th>
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) == true ? (
                  <>
                    <th>SEO & Independent Hosting</th>
                  </>
                ) : (
                  <></>
                )}
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) == true ? (
                  <>
                    <th>Auto Scaling [unlimited users access]</th>
                  </>
                ) : (
                  <></>
                )}
                <th>Monthly Cost</th>
                <th>Yearly Cost</th>
                <th>To be Paid on Upgrade</th>
              </tr>
            </thead>
            <tbody>
              {this.state.license
                .filter(
                  (f) =>
                    f.LicenseTypeId > this.context.selectedProduct.storeTypeId
                )
                .map((lic) => (
                  <>
                    <tr
                      className="text-center"
                      style={{
                        backgroundColor:
                          this.context.selectedProduct.storeTypeId ==
                          lic.LicenseTypeId
                            ? "#F1F1EC"
                            : "white",
                      }}
                    >
                      <td>
                        <Form.Check
                          type="radio"
                          name={lic.LicenseTypeId}
                          id="selectedLicense"
                          className="text-white fw-bold"
                          style={{ fontSize: "18px" }}
                          disabled={
                            this.context.selectedProduct.storeTypeId ==
                            lic.LicenseTypeId
                          }
                          checked={
                            this.state.selectedLicenseType == lic.LicenseTypeId
                          }
                          label=""
                          onChange={(e) => this.OnChangeLicenseType(e)}
                        ></Form.Check>
                      </td>
                      <td className="text-start">
                        <h5>{lic.LicenseTypeName}</h5>
                      </td>
                      <td>{lic.TotalUsers}</td>
                      <td>{lic.DataRetention + " Months"}</td>
                      {this.context.IsECommerceProduct(
                        this.context.selectedProduct.productTypeId
                      ) == true ? (
                        <>
                          <td>
                            {lic.LicenseTypeId ==
                            this.context.LicenseType.PREMIUM
                              ? "Enabled"
                              : "Disabled"}
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                      {this.context.IsECommerceProduct(
                        this.context.selectedProduct.productTypeId
                      ) == true ? (
                        <>
                          <td>Enabled. Transaction Fee 1.5% on Online Sale.</td>
                        </>
                      ) : (
                        <></>
                      )}
                      <td>
                        {this.context
                          .GetPriceOfSelectedProductByLicenseType(
                            lic.LicenseTypeId
                          )
                          .toLocaleString("en-IN", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                            style: "currency",
                            currency: "INR",
                          })}
                      </td>
                      <td>
                        {(
                          this.context.GetPriceOfSelectedProductByLicenseType(
                            lic.LicenseTypeId
                          ) * 12
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency: "INR",
                        })}
                      </td>
                      <td>
                        {" "}
                        {this.GetUpgradeAmount(
                          lic.LicenseTypeId
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency: "INR",
                        })}
                        {" + "}
                        {"Tax(" +
                          Number(
                            this.context.GetEcSettingValueByName(
                              "taxPercentage"
                            )
                          ) +
                          "%)"}
                      </td>
                    </tr>
                  </>
                ))}
            </tbody>
          </Table>
          <div className="text-center">
            <Button
              disabled={this.state.selectedLicenseType == ""}
              onClick={(e) => {
                this.handleSubmit();
              }}
            >
              {this.state.selectedLicenseType == "" ? (
                <>Upgrade</>
              ) : (
                <>
                  Upgrade & Pay{" "}
                  {this.GetUpgradeAmountWithTax().toLocaleString("en-IN", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    style: "currency",
                    currency: "INR",
                  })}
                </>
              )}
            </Button>
          </div>
        </div>
      </>
    );
  }
}
